import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Training Implications by Workstream',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Training Implications',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Change Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Absence',
                                  y: {
                                    '#': {
                                      '@': 'absence',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Academic Staffing',
                                  y: {
                                    '#': {
                                      '@': 'academicStaffing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Adaptive',
                                  y: {
                                    '#': {
                                      '@': 'adaptive',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Banking & Setttlement',
                                  y: {
                                    '#': {
                                      '@': 'bankingAndSetttlement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Benefits',
                                  y: {
                                    '#': {
                                      '@': 'benefits',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Business Assets',
                                  y: {
                                    '#': {
                                      '@': 'businessAssets',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Compensation',
                                  y: {
                                    '#': {
                                      '@': 'compensation',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Core Financials/FDM',
                                  y: {
                                    '#': {
                                      '@': 'coreFinancialsFdm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Cross-Functional',
                                  y: {
                                    '#': {
                                      '@': 'crossFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Customer Accounts',
                                  y: {
                                    '#': {
                                      '@': 'customerAccounts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data',
                                  y: {
                                    '#': {
                                      '@': 'data',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Effort Reporting',
                                  y: {
                                    '#': {
                                      '@': 'effortReporting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Financial Accounting',
                                  y: {
                                    '#': {
                                      '@': 'financialAccounting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'General',
                                  y: {
                                    '#': {
                                      '@': 'general',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Grants',
                                  y: {
                                    '#': {
                                      '@': 'grants',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'HCM Core',
                                  y: {
                                    '#': {
                                      '@': 'hcmCore',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Integrations',
                                  y: {
                                    '#': {
                                      '@': 'integrations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Inventory Management',
                                  y: {
                                    '#': {
                                      '@': 'inventoryManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Learning',
                                  y: {
                                    '#': {
                                      '@': 'learning',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll',
                                  y: {
                                    '#': {
                                      '@': 'payroll',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Payroll Accounting',
                                  y: {
                                    '#': {
                                      '@': 'payrollAccounting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Procurement',
                                  y: {
                                    '#': {
                                      '@': 'procurement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Recruiting',
                                  y: {
                                    '#': {
                                      '@': 'recruiting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting',
                                  y: {
                                    '#': {
                                      '@': 'reporting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Supplier Accounts',
                                  y: {
                                    '#': {
                                      '@': 'supplierAccounts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Talent',
                                  y: {
                                    '#': {
                                      '@': 'talent',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Time Tracking',
                                  y: {
                                    '#': {
                                      '@': 'timeTracking',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    absence: {
      filter: {
        and: [
          {
            in: [
              'Absence',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    academicStaffing: {
      filter: {
        and: [
          {
            in: [
              'Academic Staffing',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    adaptive: {
      filter: {
        and: [
          {
            in: [
              'Adaptive',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    bankingAndSetttlement: {
      filter: {
        and: [
          {
            in: [
              'Banking & Setttlement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    benefits: {
      filter: {
        and: [
          {
            in: [
              'Benefits',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    businessAssets: {
      filter: {
        and: [
          {
            in: [
              'Business Assets',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    compensation: {
      filter: {
        and: [
          {
            in: [
              'Compensation',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    coreFinancialsFdm: {
      filter: {
        and: [
          {
            in: [
              'Core Financials/FDM',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    crossFunctional: {
      filter: {
        and: [
          {
            in: [
              'Cross-Functional',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    customerAccounts: {
      filter: {
        and: [
          {
            in: [
              'Customer Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    data: {
      filter: {
        and: [
          {
            in: [
              'Data',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    effortReporting: {
      filter: {
        and: [
          {
            in: [
              'Effort Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    financialAccounting: {
      filter: {
        and: [
          {
            in: [
              'Financial Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    general: {
      filter: {
        and: [
          {
            in: [
              'General',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    grants: {
      filter: {
        and: [
          {
            in: [
              'Grants',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    hcmCore: {
      filter: {
        and: [
          {
            in: [
              'HCM Core',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    integrations: {
      filter: {
        and: [
          {
            in: [
              'Integrations',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    inventoryManagement: {
      filter: {
        and: [
          {
            in: [
              'Inventory Management',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    learning: {
      filter: {
        and: [
          {
            in: [
              'Learning',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payroll: {
      filter: {
        and: [
          {
            in: [
              'Payroll',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    payrollAccounting: {
      filter: {
        and: [
          {
            in: [
              'Payroll Accounting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    procurement: {
      filter: {
        and: [
          {
            in: [
              'Procurement',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    recruiting: {
      filter: {
        and: [
          {
            in: [
              'Recruiting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reporting: {
      filter: {
        and: [
          {
            in: [
              'Reporting',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    supplierAccounts: {
      filter: {
        and: [
          {
            in: [
              'Supplier Accounts',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    talent: {
      filter: {
        and: [
          {
            in: [
              'Talent',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    timeTracking: {
      filter: {
        and: [
          {
            in: [
              'Time Tracking',
              {
                '??': [
                  {
                    '@.': '!workstream',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
